// angular import
import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

// Project import
import { AdminComponent } from './theme/layouts/admin-layout/admin-layout.component';
import { GuestLayoutComponent } from './theme/layouts/guest-layout/guest-layout.component';
import { AuthGuard } from './Shared/Guard/auth.guard';
import { PageNotFoundComponent } from './Authmodules/page-not-found/page-not-found.component';

const routes: Routes = [
  {
    path: '',
    redirectTo: '/login',
    pathMatch: 'full'
  },
  {
    path: '',
    component: AdminComponent,
    children: [
      {
        path: 'contractor-dashboard',
        redirectTo: '/contractor-dashboard',
        pathMatch: 'full'
      },
      {
        path: 'contractor-dashboard',
        loadComponent: () => import('./demo/dashboard/default/default.component').then((c) => c.DefaultComponent),
        canActivate: [AuthGuard],
      },
      {
        path: 'dashboard',
        loadComponent: () => import('./demo/dashboard/default/default.component').then((c) => c.DefaultComponent),
        // canActivate: [AuthGuard],
      },
      {
        path: 'color',
        canActivate: [AuthGuard],
        loadComponent: () => import('./demo/component/basic-component/color/color.component').then((c) => c.ColorComponent)
      },
      {
        path: 'qr-generator',
        // canActivate: [AuthGuard],
        loadComponent: () => import('./Components/Common/qr-code-generator/qr-code-generator.component').then((c) => c.QrCodeGeneratorComponent)
      },
      {
        path: 'formio-custom',
        loadComponent: () =>
          import('./formio-custom/formio-custom-page.component').then(m => m.FormioCustomPageComponent)
      },
      {
        path: 'formio-builder',
        loadComponent: () =>
          import('./form-builder/form-builder.component').then(m => m.FormBuilderComponent),
        data: { showResponsiveControls: true }
      },

      {
        path: 'formio-data',
        loadComponent: () =>
          import('./formio-data/saved-data.component').then(m => m.SavedDataComponent),
        data: { showResponsiveControls: true }
      },
      {
        path: 'forms-list',
        loadComponent: () =>
          import('./forms-list/forms-list.component').then(m => m.FormsListComponent),
      },
      {
        path: 'case-management',
        loadComponent: () =>
          import('./case-management/case-management.component').then(m => m.CaseManagementComponent),
        canActivate: [AuthGuard],
      },
      {
        path: 'group-app',
        loadComponent: () =>
          import('./group-app/group-app.component').then(m => m.GroupAppComponent),
        canActivate: [AuthGuard],
      },
      {
        path: 'app-form',
        loadComponent: () =>
          import('./app-form/app-form.component').then(m => m.AppFormComponent),
        canActivate: [AuthGuard],
      },
      {
        path: 'page-master',
        loadComponent: () =>
          import('./page-master/page-master.component').then(m => m.PageMasterComponent),
        canActivate: [AuthGuard],
      },
      {
        path: 'encrypted-form',
        loadComponent: () =>
          import('./Components/encrypted-form/encrypted-form.component').then(m => m.EncryptedFormComponent)
      },
      {
        path: 'form-viewer',
        loadComponent: () =>
          import('./form-viewer/form-viewer.component').then(m => m.FormViewerComponent),
        data: { showResponsiveControls: true }
      },
      {
        path: 'form-crud/:formId',
        loadComponent: () =>
          import('./form-crud/form-crud.component').then(m => m.FormCrudComponent),
        data: { showResponsiveControls: true }
      },
      {
        path: 'facebook-login',
        loadComponent: () =>
          import('./Authmodules/login-facebook/login.component').then(m => m.LoginFacebookComponent)
      },
      {
        path: 'auth-callback',
        loadComponent: () =>
          import('./Authmodules/auth-callback/auth-callback.component').then(m => m.AuthCallbackComponent)
      },
      {
        path: 'popup-callback',
        loadComponent: () =>
          import('./popup-callback/popup-callback.component').then(m => m.PopupCallbackComponent)
      },
      {
        path: 'sample-page',
        loadComponent: () => import('./demo/others/sample-page/sample-page.component').then((c) => c.SamplePageComponent),
        canActivate: [AuthGuard],
      },
      {
        path: 'location',
        loadComponent: () => import('../app/Components/Common/geo-location/geo-location.component').then((c) => c.GeoLocationComponent),
        canActivate: [AuthGuard],
      },
      {
        path: 'attendance',
        loadChildren: () => import('./features-modules/face-recognition/faceRecognitionUI.module').then(m => m.FaceRecognitionUIModule)
      },
    ]
  },
  {
    path: 'qr-scanner',
    // canActivate: [AuthGuard],
    loadComponent: () => import('./Components/Common/qr-code-reader/qr-code-reader.component').then((c) => c.QRCodeReaderComponent)
  },
  {
    path: 'formio-custom',
    loadComponent: () => import('./formio-custom/formio-custom-page.component').then(m => m.FormioCustomPageComponent)
  },

  {
    path: '',
    component: GuestLayoutComponent,
    children: [
      {
        path: 'login',
        loadComponent: () => import('./Authmodules/login/login.component').then((c) => c.LoginComponent)
        // loadComponent: () => import('./Components/Common/qr-code-reader/qr-code-reader.component').then((c) => c.QRCodeReaderComponent)

      },
      {
        path: 'register',
        loadComponent: () =>
          import('./demo/pages/authentication/auth-register/auth-register.component').then((c) => c.AuthRegisterComponent)
      }
    ]
  },
  { path: '**', component: PageNotFoundComponent },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
